import { create } from 'zustand';

interface QuizProgressState {
  current: number;
  total: number;
  correctCount: number;
  isActive: boolean;
}

interface QuizProgressActions {
  setProgress: (current: number, total: number, correctCount: number) => void;
  clear: () => void;
}

type QuizProgressStore = QuizProgressState & QuizProgressActions;

const initialState: QuizProgressState = {
  current: 0,
  total: 0,
  correctCount: 0,
  isActive: false,
};

export const useQuizProgressStore = create<QuizProgressStore>()((set) => ({
  ...initialState,

  setProgress: (current, total, correctCount) =>
    set({ current, total, correctCount, isActive: true }),

  clear: () => set(initialState),
}));
